import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <section className="px-4 md:px-8 py-24 flex flex-col items-center text-center">
      <span className="font-heading font-bold text-[7rem] md:text-[10rem] leading-none text-background-200 select-none">
        404
      </span>
      <h1 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 -mt-6">
        这条线索暂时找不到
      </h1>
      <p className="mt-3 text-sm text-foreground-600 max-w-md leading-relaxed">
        页面可能已被调整，或者链接输入有误。你可以从下面的入口继续浏览。
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-primary-600 text-background-50 text-sm font-medium hover:bg-primary-700 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
        <Link
          to="/faq"
          className="inline-flex items-center gap-2 h-11 px-6 rounded-md border border-background-300 text-foreground-800 text-sm font-medium hover:border-primary-400 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
        >
          常见问题
        </Link>
      </div>
    </section>
  );
}